/**
 * Backward compatibility re-export
 * The ResponsiveModal component has been refactored into a modular structure
 * for better maintainability and separation of concerns.
 * 
 * All exports remain the same for backward compatibility.
 */

export { ResponsiveModal, useResponsiveModal } from "./responsive-modal/ResponsiveModal";
export type { ResponsiveModalProps } from "./responsive-modal/types";
